import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ShopComponent } from './pages/shop/shop.component';
import { ContactComponent } from './pages/contact/contact.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { AccountComponent } from './pages/account/account.component';
import { ProductDetailComponent } from './pages/product-detail/product-detail.component';
import { TermCondComponent } from './pages/term-cond/term-cond.component';
import { RefundReturnComponent } from './pages/refund-return/refund-return.component';
import { ShippingDeliveryComponent } from './pages/shipping-delivery/shipping-delivery.component';
import { VideoComponent } from './components/video/video.component';
import { AuthGuard } from './guard/auth.guard';

export const routes: Routes = [
    { path: 'about-us', component: AboutComponent },
    { path: 'shop', component: ShopComponent },
    { path: 'product-detail/:slug', component: ProductDetailComponent },
    { path: 'contact-us', component: ContactComponent },
    { path: 'gallery', component: VideoComponent },
    {
        path: 'account',
        component: AccountComponent,
        loadChildren: () => import('./pages/account/account.routes').then(m => m.routes),
        canActivateChild:[AuthGuard]
    },
    { path: 'term_condition', component: TermCondComponent },
    { path: 'refund_returns', component: RefundReturnComponent },
    { path: 'shipping_delivery', component: ShippingDeliveryComponent },

    { path: 'signup', component: SignUpComponent },
    { path: '', component: HomeComponent, },
    { path: '**', redirectTo: '', pathMatch: 'full' },
];

